<template>
<div>
	<h2>EAN Überprüfung</h2>
	<div class="d-flex">
		<input type="text" v-model="ean" class="form-control mr-2" ref="ean" @keydown.enter="checkEan" style="max-width: 300px !important;" placeholder="Geben Sie eine EAN ein" />
		<b-form-select
				v-model="selectedVendor"
				:options="vendors"
				class="mr-2"
				style="max-width: 250px !important;"
				placeholder="Händler auswählen"
		></b-form-select>
		<b-btn @click="checkEan"  class="btn btn-primary">Überprüfen <b-spinner v-if="eanRequestInProgress" small  label="Spinning"/></b-btn>
	</div>
	<div v-if="message !== ''" class="mt-3">
		<p>
			{{ message }}
			<span v-if="materialLink !== ''">
				<a :href="materialLink" target="_blank">Material</a>
			</span>
		</p>

	</div>
	<div v-if="showAsinSelection">
		<div v-if="requestJob?.title">
			<span >Händler-Produkttitel ({{vendors.find((v) => v.value === selectedVendor)?.text }}):</span>
			<h4>{{ requestJob?.title }}</h4>
		</div>
		<b-table
				v-if="requestJob"
				id="table-resolve-asin"
				:items="asinCandidateItems"
				:fields="fields"
				small
		><!-- table -->
			<template v-slot:cell(asin)="row">
				<b-button
						v-if="row.item !== 'keine'"
						block
						size="sm"
						@click="selectAsin(row.item[0].asin.toUpperCase())"
						:variant="resolveButtonVariant(row.item[0].asin.toUpperCase())"
				><!-- button -->
					<b>{{ row.item[0].asin.toUpperCase() }}</b>
				</b-button>
				<b-button
						v-else
						block
						:variant="
              requestJob &&
              requestJob.manualAsin &&
              row.item.asin === requestJob.manualAsin
                ? 'info'
                : 'outline-info'
            "
						@click="selectAsin(row.item)"
						size="sm"
				>keine</b-button
				>
			</template>

			<template v-slot:cell(market)="row">
				<div v-if="row.item != 'keine'">
					<b-button
							v-for="(item, i) in row.item"
							:key="i"
							pill
							size="sm"
							@click="
                openInNewTab(
                  `${marketLinks[item.market.id]}/dp/${item.asin.toUpperCase()}`,
                )
              "
							class="m-1"
					><!-- button -->
						<!--                        {{markets.find( m => m.id == row.item.market.id).name.substr(7,2)}}-->
						{{ item.market.name.slice(-2) }}
					</b-button>
					<b-button
							v-if="row.item && row.item.length > 1"
							@click="openAllMarketsInNewTab(row.item[0].asin.toUpperCase())"
							pill
							variant="outline-primary"
							size="sm"
							class="m-1"
					>alle</b-button
					>
				</div>
			</template>
		</b-table>
		<div class="mt-3" v-if="requestJob">
			<b-btn :disabled="!requestJob.manualAsin" variant="primary" @click="submit">Absenden <b-spinner v-if="rjRequestInProgress" small  label="Spinning"/></b-btn>
		</div>
	</div>
	<modal-error-component v-model="modalError"></modal-error-component>
</div>
</template>

<script>
import axios from "axios";
import ModalErrorComponent from "./ModalErrorComponent.vue";

export default {
	name: "EanCheck",
	components: {ModalErrorComponent},
	data() {
		return {
			ean: "",
			message: "",
			selectedVendor: null,
			vendors: [],
			showAsinSelection: false,
			requestJob: null,
			asins: [],
			asinToMarkets: null,
			fields: [
				{ key: "asin", label: "ASIN" },
				{ key: "market", label: "Marktplatz" },
			],
			materialLink: "",
			markets: [],
			eanRequestInProgress: false,
			rjRequestInProgress: false,
			marketLinks: {
				1: "https://www.amazon.com",
				2: "https://www.amazon.ca",
				3: "https://www.amazon.com.au",
				4: "https://www.amazon.co.jp",
				5: "https://www.amazon.de",
				6: "https://www.amazon.fr",
				7: "https://www.amazon.nl",
				8: "https://www.amazon.es",
				9: "https://www.amazon.it",
				10: "https://www.amazon.com.tr",
				11: "https://www.amazon.co.uk",
				22: "https://www.amazon.com.mx",
				23: "https://www.amazon.ae",
				24: "https://www.amazon.com.br",
				25: "https://www.amazon.sg",
				26: "https://www.amazon.se",
			},
			modalError: {
				show: false,
				error: null,
				title: "",
				message: "",
			},
		};
	},
	computed: {
		asinCandidateItems: function () {
			return this.asinToMarkets
				? Object.values(this.asinToMarkets)
				: [];
		},
	},
	methods:{
		checkEan() {
			if(this.eanRequestInProgress || this.rjRequestInProgress) return;
			this.message = "";
			if(this.ean.trim() === "" || this.selectedVendor === null){
				this.message = "Bitte geben Sie eine EAN ein und wählen Sie einen Händler aus.";
				return;
			}
			this.eanRequestInProgress = true;
			axios.post('/eancheck', {
				ean: this.ean.trim(),
				vendorId: this.selectedVendor
				})
				.then(response => {
					this.eanRequestInProgress = false;
					this.message = response.data.message;
					this.handleResponseStates(response.data.state, response.data?.materialId);
					this.requestJob = response.data?.requestJob;
					if(response.data.ambiguousAsins){
						this.formatAsinCandidates(response.data.ambiguousAsins);
					}

				})
				.catch(error => {
					this.eanRequestInProgress = false;
					this.modalError = {
						show: true,
						error: error,
						title: 'Fehler bei der EAN Überprüfung',
						message: 'Bei der Überprüfung der EAN ist ein Fehler aufgetreten.'
					};
					console.error(error);
				});
		},
		handleResponseStates(state, materialId = null){
		// possible statest: not_found, blocked, unknown, actionRequired, finished, pending, error, created, others
			if(state === 'actionRequired'){
				this.showAsinSelection = true;

				this.materialLink = "";
			} else if (state === 'finished' && materialId != null || state === 'materialExists') {
				this.materialLink = `/material/${materialId}/edit`;
			} else {
				this.showAsinSelection = false;
				this.materialLink = "";
			}
		},
		formatAsinCandidates(asinCandidates){
			this.asinToMarkets = {};
			//looping over the asinCandidates
			for (const asin of Object.keys(asinCandidates)) {
				//looping over the marketplaces for a candidate
				const candidates = [];

				for (const candidate of asinCandidates[asin]) {
					// check if that current asin is the same as this.modalResolveAsin.asinToMarkets[asin]

					let candidate_ = {};
					candidate_.asin = asin;
					candidate_.market = this.markets.find(
							(m) => m.identifier == candidate.marketIdentifier,
					);

					candidates.push(candidate_);

					if (this.asinToMarkets?.[asin] &&
							candidates.includes((c) => c?.asin === asin)
					) {
					}

				}
				this.asinToMarkets[asin] = candidates;
			}
			this.asinToMarkets["keine"] = "keine";
			this.asins = Object.keys(
					this.asinToMarkets,
			);
		},
		selectAsin(asin) {
			this.requestJob.manualAsin = asin.toUpperCase();
		},
		resolveButtonVariant(selectedAsin) {
			if (selectedAsin === "keine")
				return requestJob.manualAsin === "keine" ? "info" : "info-outline";

			return this.requestJob &&
			this.requestJob.manualAsin &&
			selectedAsin === this.requestJob.manualAsin
					? "primary"
					: "secondary";
		},
		openAllMarketsInNewTab(asin) {
			const asinCandidate = asin;
			let urls = [];
			this.asinToMarkets[asinCandidate].forEach((ac) =>
					Object.keys(ac).forEach(
						() => {
							if (urls.includes(`${this.marketLinks[ac.market.id]}/dp/${asinCandidate.toUpperCase()}`))
								return;
							urls.push(`${this.marketLinks[ac.market.id]}/dp/${asinCandidate.toUpperCase()}`);//ac asinCandidate
						},
					),
			);
			this.synch.openMultipleTabs(urls);
		},
		openInNewTab(url) {
			window.open(url, "_blank").focus();
		},
		submit() {
			if(!this.requestJob.manualAsin || this.rjRequestInProgress) return;
			if (this.requestJob.manualAsin.toUpperCase() === "KEINE") {
				this.requestJob.manualAsin = null;
				this.requestJob.asin = null;
				this.requestJob.state = "finished";
				this.requestJob.errorCode = 1547725108; // TODO: was hat es mit dem Error Code auf sich?
				this.rjRequestInProgress = true;
				axios
						.put("/mds/request_job", this.requestJob)
						.then(() => {
							this.rjRequestInProgress = false;
							this.$bvToast.toast(`Asin-Auswahl erfolgreich abgeschickt`, {
								autoHideDelay: 5000,
								variant: 'success'
							})
							this.reset();
						})
						.catch((error) => {
							this.rjRequestInProgress = false;
							this.modalError = {
								show: true,
								error: error,
								title: 'Fehler beim Absenden der ASIN Auswahl',
								message: 'Beim Absenden der ASIN Auswahl ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
							};
							console.error(error);
						});
			} else {
				this.requestJob.state = "manual_asin_set";
				this.requestJob.asin = null;
				this.requestJob.errorCode = 1366617151; // TODO: was hat es mit dem Error Code auf sich?
				this.rjRequestInProgress = true;
				axios
						.put("/mds/request_job", this.requestJob)
						.then(() => {
							this.$bvToast.toast(`Asin-Auswahl erfolgreich abgeschickt`, {
								autoHideDelay: 5000,
								variant: 'success'
							})
							this.rjRequestInProgress = false;
							this.reset();
						})
						.catch((error) => {
							this.rjRequestInProgress = false;
							this.modalError = {
								show: true,
								error: error,
								title: 'Fehler beim Absenden der ASIN Auswahl',
								message: 'Beim Absenden der ASIN Auswahl ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
							};
							console.error(error);
						});
			}
		},
		getAllVendor(){
			axios.get('/vendor/all_names')
				.then(response => {
					this.vendors = response.data.map(vendor => ({
						value: vendor.id,
						text: vendor.name
					}));
					this.vendors.unshift({ value: null, text: 'Händler auswählen' });
				})
				.catch(error => {
					this.modalError = {
						show: true,
						error: error,
						title: 'Fehler beim Abrufen der Lieferanten',
						message: 'Beim Abrufen der Händler ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
					};
					console.error('Fehler beim Abrufen der Händler:', error);
				});
		},
		getAllMarkets(){
			axios.get('/mds/market')
				.then(response => {
					this.markets = response.data;
				})
				.catch(error => {
					this.modalError = {
						show: true,
						error: error,
						title: 'Fehler beim Abrufen der Märkte',
						message: 'Beim Abrufen der Märkte ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
					};
					console.error(error);
				});
		},
		reset(){
			this.ean = "";
			this.message = "";
			this.showAsinSelection = false;
			this.requestJob = null;
			this.asins = [];
			this.asinToMarkets = null;
			this.materialLink = "";
			this.$refs.ean.focus();
		}
	},
	created(){
		this.getAllVendor();
		this.getAllMarkets();
		this.selectedVendor = this.vendors.length > 1 ? this.vendors[1].value : null;
	}
}

</script>

<style scoped>

</style>